<template>
  <!-- "Voir" popup: the constat's photos. Devloc staff add (camera /
       upload) and delete; everyone can open and download. -->
  <b-modal
    :active="active"
    :width="760"
    @close="$emit('close')"
  >
    <div
      v-if="element"
      class="modal-card"
    >
      <header class="modal-card-head">
        <p class="modal-card-title title is-6 mb-0">
          {{ $t("photos").capitalize() }} — {{ $t(element.type) }}, {{ $shortDate(element.date, false) }}
        </p>
        <button
          type="button"
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        />
      </header>

      <section class="modal-card-body">
        <div
          v-if="element.media && element.media.length"
          class="photo-grid"
        >
          <div
            v-for="file in element.media"
            :key="file.id"
            class="photo-cell"
          >
            <a
              :href="file.url"
              target="_blank"
              rel="noopener"
            >
              <img
                :src="file.thumb_url || file.url"
                :alt="file.file_name"
              >
            </a>
            <div class="photo-tools">
              <a
                :href="$laravel.route('api.property-inspection-elements.media.download_one', { propertyInspectionElement: element.id, mediaId: file.id })"
                class="button is-small is-white"
                :title="$t('download').capitalize()"
              >
                <span class="icon"><i class="mdi mdi-download" /></span>
              </a>
              <button
                v-if="canManage"
                type="button"
                class="button is-small is-white has-text-danger"
                :title="$t('delete').capitalize()"
                :disabled="busy"
                @click="removePhoto(file)"
              >
                <span class="icon"><i class="mdi mdi-delete-outline" /></span>
              </button>
            </div>
          </div>
        </div>
        <p
          v-else
          class="has-text-grey has-text-centered py-5"
        >
          {{ $t("no_photos") }}
        </p>

        <div
          v-if="canManage"
          class="mt-4"
        >
          <v-photo-picker
            :loading="busy"
            @files="addPhotos"
          />
        </div>
      </section>

      <footer class="modal-card-foot is-justify-content-flex-end">
        <!-- Save every photo on the computer (zip) -->
        <a
          v-if="element.media && element.media.length"
          :href="$laravel.route('api.property-inspection-elements.media.download', { propertyInspectionElement: element.id })"
          class="button"
        >
          <span class="icon"><i class="mdi mdi-download" /></span>
          <span>{{ $t('download_all') }}</span>
        </a>
        <b-button
          :label="$t('close')"
          @click="$emit('close')"
        />
      </footer>
    </div>
  </b-modal>
</template>

<script>
import notificator from "@/services/notificator";
import PhotoPicker from "./PhotoPicker.vue";

export default {
  components: {
    "v-photo-picker": PhotoPicker,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    element: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  computed: {
    canManage() {
      return !!(this.element && this.element.can && this.element.can.update);
    },
  },
  methods: {
    addPhotos(files) {
      if (!files.length || this.busy) {
        return;
      }
      this.busy = true;

      const data = new FormData();

      files.forEach((file) => data.append("photos[]", file, file.name));

      this.$http
        .post(
          this.$laravel.route("api.property-inspection-elements.media.store", {
            propertyInspectionElement: this.element.id,
          }),
          data
        )
        .then((response) => {
          notificator.open({ message: response.data.message, type: "success" });
          this.$emit("changed");
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.busy = false;
        });
    },
    // Straight delete, no confirmation
    removePhoto(file) {
      if (this.busy) {
        return;
      }
      this.busy = true;
      this.$http
        .delete(
          this.$laravel.route("api.property-inspection-elements.media.destroy", {
            propertyInspectionElement: this.element.id,
            mediaId: file.id,
          })
        )
        .then(() => {
          this.$emit("changed");
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.busy = false;
        });
    },
  },
};
</script>

<style scoped>
.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 10px;
}
.photo-cell {
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  overflow: hidden;
  background: #fafafa;
}
.photo-cell img {
  display: block;
  width: 100%;
  height: 130px;
  object-fit: cover;
}
.photo-tools {
  display: flex;
  justify-content: flex-end;
  gap: 2px;
  padding: 2px 4px;
}
</style>
